import { Injectable, Output, EventEmitter, Inject } from '@angular/core';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { MODULE_NAMES } from '@shared/constants/module-names.ts';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class StepsService {
  headerTexts = { title: '', caption: '' };
  currentStepId = 0;
  doneStepIds = [];
  transitionDirection = 'RIGHT';
  isCompleted = false;
  progressValue = 0;
  progressSteps = [
    {
      id: 0,
      title: 'Personal Details',
      currentStep: true, // should be true, change for test
      doneStep: false
    },
    {
      id: 1,
      title: 'Contact Information',
      currentStep: false,
      doneStep: false
    },
    {
      id: 2,
      title: 'Pre-Order Details',
      currentStep: false,
      doneStep: false
    }
  ];
  moduleName;

  @Output()
  updateCurrentStepId: EventEmitter<any> = new EventEmitter();

  @Output()
  updateDoneStepId: EventEmitter<any> = new EventEmitter();

  @Output()
  updateTransitionDirection: EventEmitter<any> = new EventEmitter();

  @Output()
  updateHeaderTexts: EventEmitter<any> = new EventEmitter();

  @Output()
  updateFirstName: EventEmitter<any> = new EventEmitter();

  @Output()
  updateSignupCompleted: EventEmitter<any> = new EventEmitter();

  @Output()
  updateProgressValue: EventEmitter<any> = new EventEmitter();

  constructor(
    @Inject(SESSION_STORAGE) private sessionStorage: WebStorageService,
    private activatedRoute: ActivatedRoute
  ) {}

  setCurrentStep(id) {
    this.currentStepId = id;
    this.progressSteps.map(step => {
      step.currentStep = step.id === id;
    });
    // this.updateCurrentStepId.emit(this.currentStepId);
  }

  initSteps() {
    return this.progressSteps;
  }

  getCurrentStep() {
    return this.currentStepId;
  }

  setDoneSteps(ids) {
    this.doneStepIds = ids;
    this.progressSteps.map(step => {
      step.doneStep = false;
    });

    for (const id of ids) {
      this.progressSteps.map(step => {
        if (step.id === id) {
          step.doneStep = !step.doneStep;
        }
      });
    }
    // this.updateDoneStepId.emit(this.doneStepIds);
  }

  getDoneSteps() {
    return this.doneStepIds;
  }

  setTransitionDirection(direction) {
    this.transitionDirection = direction;
    this.updateTransitionDirection.emit(this.transitionDirection);
  }

  getTransitionDirection() {
    return this.transitionDirection;
  }

  setSession(key, val) {
    this.sessionStorage.set(key, val);
    this.updateFirstName.emit(this.getSession(key));
  }

  getSession(key) {
    return this.sessionStorage.get(key);
  }

  removeSession(key) {
    this.sessionStorage.remove(key);
  }

  setHeaderTexts(texts) {
    this.headerTexts = texts;
    this.updateHeaderTexts.emit(this.headerTexts);
  }

  getHeaderTexts() {
    return this.headerTexts;
  }

  setSignupCompleted(completed) {
    this.isCompleted = completed;
    this.updateSignupCompleted.emit(this.isCompleted);
  }

  getSignupCompleted() {
    return this.isCompleted;
  }

  setProgressValue(value) {
    this.progressValue = value;
    this.updateProgressValue.emit(this.progressValue);
  }

  checkSessionExist(key) {
    return !!this.getSession(key);
  }

  isCurrentModulePreOrder(str) {
    return str === MODULE_NAMES.PRE_ORDER;
  }

  getModuleName() {
    return this.moduleName;
  }
  setModuleName(name) {
    this.moduleName = name;
  }
}
